<script setup lang="ts"></script>

<template>
  <div>
    <h1>Perfil</h1>
    <router-link to="/login">
      Sair
    </router-link>
  </div>
</template>
